import React from 'react';
import Tooltip from '../../_custom/Tooltip/Tooltip';
// Imported directly (not via the `_custom` barrel) — the barrel re-exports DataTable,
// which pulls in PlateEditor's ESM color-picker deps and breaks under Jest.
import Button from '../../_custom/Button/Button';

export interface EmailLenderButtonProps {
    enabled: boolean;
    disabledReason: string;
    onClick: () => void;
}

/**
 * "Email Lender" button for the borrower Data Pending screen (RECUR-27563 R1/R2).
 * Enablement is computed by getEmailLenderButtonState and passed in; when disabled, the
 * tooltip shows disabledReason (EMAIL_LENDER_DISABLED_REASONS). Purely presentational so
 * the enabled/disabled render is easy to test.
 */
const EmailLenderButton: React.FC<EmailLenderButtonProps> = ({ enabled, disabledReason, onClick }) => {
    return (
        <Tooltip
            content={enabled ? 'Email the lender about the pending queries below' : disabledReason}
            direction="bottom"
            fitContent={true}
            style={{
                bottom: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                borderRadius: '12px',
            }}
            contentCss={{
                textAlign: 'center',
            }}
        >
            <Button
                text="Email Lender"
                onClick={onClick}
                disabled={!enabled}
                variant="secondary"
                // Purple text only while enabled (Figma: purple secondary button). When disabled,
                // match Compose Email's disabled look (Button's primary-disabled text color) —
                // secondary's own disabled text (--secondary-button-text) is too light to read
                // against the shared grey disabled background.
                textstyle={{ color: enabled ? 'var(--primary-purple)' : 'var(--primary-button-text)' }}
                style={{ margin: 0, fontSize: '0.875rem', padding: '0.75rem 1rem' }}
            />
        </Tooltip>
    );
};

export default EmailLenderButton;
